export type SelectedPaczkomat = {
  code: string;
  name: string;
  street: string;
  postCode: string;
  city: string;
  latitude: number;
  longitude: number;
};

export type LegacyPaczkomat = {
  code?: string;
  address?: string;
};

export function formatPaczkomat(
  p: Partial<SelectedPaczkomat> & LegacyPaczkomat,
): string {
  const code = p.code ?? '';
  if (p.street) {
    return `${code} · ${p.street}, ${p.postCode ?? ''} ${p.city ?? ''}`.trim();
  }
  return `${code} · ${p.address ?? ''}`.trim();
}
